<template lang="pug">
  content-box(color='blue')
    template(slot='header') View Historical Indexes
    div
      p Historical Indexes are provided by the county to
        |  expand access to land records in their original form,
        | to protect delicate original books, and to aid
        | the ability to locate historical documents by party name.
      manual-index-search-simple(:sourceId='sourceId')
</template>
<script>
import ContentBox from '@/components/content-box'
import ManualIndexSearchSimple from '@/components/recorder/manual-index-search-widget-simple'

export default {
  name: 'manual-index-search-widget',
  components: {
    ContentBox,
    ManualIndexSearchSimple,
  },
  props: {
    sourceId: {
      type: Number,
      required: false
    }
  }
}
</script>
